<script>
    import { Tabs,Tab } from 'svelte-chota';
    import PersonalProjects from "./PersonalProjects.svelte";
    import FreelanceProjects from "./FreelanceProjects.svelte";
    let active_tab = 0;
</script>

<main>
    <Tabs full bind:active={active_tab} style="position: fixed; top: 0; left: 0; width: 100vw; background-color:#FFF;">
        <Tab>Personal Projects</Tab>
        <Tab>Freelance Projects</Tab>
    </Tabs>
    {#if active_tab == 0}
        <PersonalProjects />
    {/if}
    {#if active_tab == 1}
        <FreelanceProjects />
    {/if}
</main>
